// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RRNq9","questions":"styles_questions__2o_eX","footer":"styles_footer__3_xbv"};